export default {
  install: (app, options) => {
    const loadBeamer = async () => {
      const beamerConfig = document.createElement("script");
      beamerConfig.textContent = `
        var beamer_config = {
          product_id: '${options.productId}'
        };
      `;
      document.head.appendChild(beamerConfig);

      const beamerScript = document.createElement("script");
      beamerScript.src = "https://app.getbeamer.com/js/beamer-embed.js";
      beamerScript.async = true;

      const scriptLoadPromise = new Promise((resolve, reject) => {
        beamerScript.onload = resolve;
        beamerScript.onerror = reject;
      });

      document.head.appendChild(beamerScript);
      await scriptLoadPromise;

      console.log("Beamer script loaded successfully");
    };

      loadBeamer().catch((error) => {
        console.error("Failed to load Beamer script:", error);
      });
  },
};
